export const CurriculumGoalsTick = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect fill="white" height="31" rx="15.5" width="31" x="0.5" y="0.5" />
    <rect fill="#E9F5FE" height="31" rx="15.5" width="31" x="0.5" y="0.5" />
    <rect height="31" rx="15.5" stroke="#155C95" width="31" x="0.5" y="0.5" />
    <path
      d="M13.5512 19.5155L22.1897 10.877C22.3384 10.7282 22.5124 10.6522 22.7117 10.649C22.9111 10.6459 23.0883 10.7219 23.2435 10.877C23.3986 11.0322 23.4762 11.2104 23.4762 11.4115C23.4762 11.6129 23.3986 11.7911 23.2435 11.9463L14.184 21.0213C14.0031 21.2019 13.7922 21.2923 13.5512 21.2923C13.3102 21.2923 13.0993 21.2019 12.9185 21.0213L8.74348 16.8463C8.59481 16.6974 8.52148 16.5208 8.52348 16.3163C8.52531 16.1119 8.60381 15.9322 8.75898 15.777C8.91414 15.6219 9.09231 15.5443 9.29348 15.5443C9.49481 15.5443 9.67306 15.6219 9.82823 15.777L13.5512 19.5155Z"
      fill="#155C95"
    />
  </svg>
);
